export default __webpack_public_path__ + "static/media/HandMobileScan.1b8ada32.svg";